import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./styling/restraunt.css";
import './styling/restraunt-s.css';
import * as Sentry from "@sentry/react";
import ImageSlider from "../components/CustomSlider";
import mapsIconPulci from "./assets/mapsPulci.svg";
import instaYellow from "./assets/insta-yellow.svg";
import kerstMenu from "./assets/KerstMenu26.jpg";

import  { getActivePdf } from '../dataSource/PDFSource';

function Restraunt() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 1200px)").matches
  );
  const [isOpeningMenuPulcinos, setOpeningMenuPulcinos] = useState(false);
  const [isKerstMenuOpen, setKerstMenuOpen] = useState(false);

  // Sluit de kerstmenu-lightbox met Escape
  useEffect(() => {
    if (!isKerstMenuOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setKerstMenuOpen(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isKerstMenuOpen]);

  let isFetchingPdf = false; // Prevent multiple simultaneous calls

  const handleOpenPdf = async (restaurant) => {

    const link = document.createElement("a");
    link.href = "";
    link.target = "_blank";
    document.body.appendChild(link);

    if (isFetchingPdf) {
      console.log("Already fetching the PDF. Exiting early.");
      return; // Prevent concurrent executions
    }

    setOpeningMenuPulcinos(true);

    console.log("Starting to fetch the PDF...");
    isFetchingPdf = true; // Lock the execution

    const maxRetries = 3; // Maximum number of retry attempts
    const retryDelay = 2000; // Delay between retries in milliseconds

    // Maakt elke waarde veilig loggbaar zonder enorme payload
    const describe = (value) => {
      if (typeof value === "string") return value.slice(0, 200);
      try {
        return JSON.stringify(value)?.slice(0, 200) ?? String(value);
      } catch {
        return Object.prototype.toString.call(value);
      }
    };

    const fetchWithRetry = async (retries) => {

  let lastError = null;
  let lastInvalidValue; // undefined = er kwam nooit een respons terug

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const menu = await getActivePdf(restaurant);

      if (
        menu &&
        typeof menu === "string" &&
        (menu.startsWith("http") || menu.startsWith("blob:"))
      ) {
        return menu;
      }

      lastInvalidValue = menu;

      console.log(`Invalid menu URL (Attempt ${attempt}):`, menu);

      Sentry.addBreadcrumb({
        category: "menu-pdf",
        level: "warning",
        message: `Poging ${attempt}: ongeldige menu-URL`,
        data: { received: describe(menu), receivedType: typeof menu },
      });

    } catch (error) {
      lastError = error;

      console.error(
        `Error during fetch (Attempt ${attempt}):`,
        error
      );

      Sentry.addBreadcrumb({
        category: "menu-pdf",
        level: "error",
        message: `Poging ${attempt}: ${error?.name ?? "Error"}`,
        data: { message: error?.message },
      });
    }

    if (attempt < retries) {
      await new Promise((resolve) =>
        setTimeout(resolve, retryDelay)
      );
    }
  }

  const shared = {
    tags: {
      feature: "menu-pdf",
      restaurant: String(restaurant),
      function: "fetchWithRetry",
      browserOnline: String(navigator.onLine),
    },
    extra: {
      attempts: retries,
      retryDelay,
      // page en userAgent stuurt Sentry zelf al mee
      lastValue:
        lastInvalidValue === undefined
          ? "(geen respons)"
          : describe(lastInvalidValue),
      lastValueType: typeof lastInvalidValue,
    },
  };

  if (lastError) {
    Sentry.captureException(lastError, {
      ...shared,
      tags: { ...shared.tags, reason: "fetch_threw" },
      fingerprint: ["menu-pdf", "fetch_threw"],
    });
  } else {
    Sentry.captureMessage(
      "Menu fetch failed: invalid response",
      {
        ...shared,
        level: "error",
        tags: { ...shared.tags, reason: "invalid_response" },
        fingerprint: ["menu-pdf", "invalid_response"],
      }
    );
  }

  return null;
};

    try {
      const menu = await fetchWithRetry(maxRetries);

      if (menu) {
        console.log("Opening the menu:", menu);

        link.href = menu;
        link.download = `Menu_${restaurant}.pdf`;
        link.click();

          // Trigger the downlo
        console.log("Menu opened successfully. Exiting function.");
        return; // Exit the function immediately after opening the menu
      } else {
        // Geen tweede Sentry-event meer: fetchWithRetry heeft hierboven al
        // gerapporteerd, met meer detail dan hier beschikbaar is.
        console.log("Failed to fetch the menu after all retries.");
        alert("Er is iets mis gegaan met het openen van het Menu...");
      }
    } finally {
      console.log("Resetting the isFetchingPdf flag.");
      isFetchingPdf = false; // Unlock execution after completing
      setOpeningMenuPulcinos(false);
    }
  };
 

  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL (e.g., #team)
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <div id="homeBox">
        <div className="navWrapper"></div>
    
        <div id="restrauntAnchor" className="splitterBox">
          <div className="infoBox">
            <div className="infoOverlay"></div>
            <div className="infoWrapper">
              <h1>
                Welkom bij <span className="yellow">Pulcinos</span>
              </h1>

              <p>
                Aan de Piushaven in Tilburg vind je Restaurant Pulcinos, de
                perfecte plek om te genieten van lekker eten, goede drankjes en
                een ontspannen sfeer. Of je nu komt voor een diner, een borrel
                of een cocktail aan de bar, je bent voor alles welkom.
              </p>

              <p>
                We serveren smaakvolle gerechten gemaakt met verse ingrediënten
                en hebben een mooie selectie cocktails en borrelhapjes. Veel van
                de cocktails zijn gemaakt met onze eigen dranken zoals de
                Limoncello, Valenti en Yuzu gin. Veel gerechten zijn
                geïnspireerd door de Italiaanse keuken maar er word eten van
                over heel de wereld geserveerd.{" "}
              </p>

              <p>
                Kom langs en geniet van alles wat Pulcinos te bieden heeft – een
                fijne plek aan het water, goed eten, drinken en gezelligheid!
              </p>

              <p>Reserveer via de knop hieronder!</p>

              <div className="buttonsBox restaurantButtons">
                <div className="restaurantButtonsPrimary">
                <a
                  href="https://restaurant-pulcinos.lurch.app/reservation/"
                  rel="noreferrer"
                  target="_blank"
                  className="checkout-btn actionBtn"
                >
                  Reserveer een Tafel
                </a>

                <button
                  className="checkout-btn actionBtn"
                  onClick={() => handleOpenPdf("pulcinos")}
                  disabled={isOpeningMenuPulcinos}
                >
                  Bekijk Menu
                </button>
                </div>

                <div className="restaurantButtonsSecondary">
                <a
                  href="https://maps.app.goo.gl/uMM7iNZJsabxVUm5A"
                  rel="noreferrer"
                  target="_blank"
                  className="checkout-btn actionBtn mapsButton"
                >
                  <img src={mapsIconPulci} alt=""></img>
                  Adres
                </a>
                <a
                  href="https://www.instagram.com/pulcinostilburg/"
                  rel="noreferrer"
                  target="_blank"
                  className="socialButton"
                >
                  <img className="instaLogo" src={instaYellow} alt=""></img>
                </a>
                </div>
              </div>
            </div>
          </div>
          <div className="imageBox">
            <div>
              <ImageSlider />
            </div>
          </div>
        </div>
      </div>

      <div id="kerstmenu" className="kerstMenuBox">
        <div className="bokeh-light"></div>
        <div className="bokeh-light"></div>

        <div className="kerstMenuHeader">
          <h2 className="kerstMenuTitle">
            Ons <span>Kerstmenu</span>
          </h2>
          <p className="kerstMenuIntro">
            Vier de feestdagen bij Pulcinos aan de Piushaven. Klik op het menu
            om het groot te bekijken.
          </p>
        </div>

        <img
          className="kerstMenuImage clickable-menu"
          src={kerstMenu}
          alt="Pulcinos kerstmenu"
          loading="lazy"
          onClick={() => setKerstMenuOpen(true)}
        />
      </div>

      {isKerstMenuOpen && (
        <div className="menuLightbox" onClick={() => setKerstMenuOpen(false)}>
          <button
            className="menuLightboxClose"
            onClick={() => setKerstMenuOpen(false)}
            aria-label="Sluiten"
          >
            &times;
          </button>
          <img
            className="menuLightboxImage"
            src={kerstMenu}
            alt="Pulcinos kerstmenu"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}

export default Restraunt;
